import StandTypeFilterField from "./stand-type-filter-field";


const StandFields = {
    TypeFilter : StandTypeFilterField
}

export default StandFields;